import { BUSINESS_REG_APP_CONSTANT } from "app/config/business-reg-app.constant"
import { getBrowserVersion } from "app/core/util/web_utils";
import { TRCAppForm } from "./tRCAppForm.model";
const clientBwser = getBrowserVersion(window.navigator.userAgent) ;
export class WebLogon {
    
    taxpayerLogonDataID = 0
    accountNbr = ""
    taxPeriod = ""
    streetNbr = "" 
    zipCode = ""
    clientBrowser = clientBwser.browser.substr(0, 200)
    browserVersion = clientBwser.browserVersion.substr(0, 200)
    createdBy = BUSINESS_REG_APP_CONSTANT.CreatedBy
    createdDt : any
    status = "Pending" ;
    pageVisited = "" ;
    webFilingId = "" ;

}

